type TeamLogoCardProps = {
    name: string;
    logo: string;
};

export default function TeamLogoCard({ name, logo }: TeamLogoCardProps) {
    return (
        <div
            className="
        relative aspect-[1.05/1] w-full overflow-hidden rounded-xl
        border border-cyan-400/60 bg-[#0b1220]
        shadow-[0_0_12px_rgba(34,211,238,0.2)]
        group
      "
        >
            <div className="absolute inset-0 bg-gradient-to-br from-[#0f2f66] via-[#101827] to-[#0a0f1a]" />

            <div className="absolute inset-0 opacity-80">
                <div className="absolute -left-[10%] top-0 h-full w-[14%] rotate-[20deg] bg-blue-500/20" />
                <div className="absolute left-[18%] top-0 h-full w-[14%] rotate-[20deg] bg-cyan-400/10" />
                <div className="absolute left-[42%] top-0 h-full w-[14%] rotate-[20deg] bg-blue-600/20" />
                <div className="absolute right-[6%] top-0 h-full w-[18%] rotate-[20deg] bg-slate-900/50" />
            </div>

            <div className="absolute inset-[1px] rounded-xl border border-cyan-300/25" />

            <div className="absolute bottom-0 right-0 h-[35%] w-[35%]">
                <div
                    className="
            absolute bottom-[10%] right-[10%] h-[60%] w-[60%]
            skew-x-[-25deg] border-b-2 border-r-2 border-cyan-300/70
            drop-shadow-[0_0_8px_rgba(103,232,249,0.7)]
          "
                />
            </div>

            <div className="relative z-10 flex h-full flex-col items-center justify-center px-2 pb-[16%] pt-[6%]">
                <img
                    src={logo}
                    alt={name}
                    className="
            max-h-[64%] max-w-[74%] object-contain
            drop-shadow-[0_6px_12px_rgba(0,0,0,0.55)]
            transition-transform duration-300 group-hover:scale-105
          "
                />

                <div className="absolute bottom-[6%] left-0 w-full px-1 text-center">
                    <p className="truncate text-[clamp(8px,0.75vw,12px)] font-semibold leading-tight text-white">
                        {name}
                    </p>
                </div>
            </div>
        </div>
    );
}